import React from "react";
import { useLanguage } from "../utils/LanguageContext";
import { useTheme } from "../utils/ThemeContext";

const Experience = () => {
  const { t } = useLanguage();
  const { theme } = useTheme();

  return (
    <section className="py-5" id="experience">
      <div className="section-accent reveal reveal-left" />
      <h2 className={`${theme === "dark" ? "title-dark" : "title"} reveal reveal-left reveal-delay-1`}>
        {t.experienceTitle}
      </h2>
      <p className="text-base md:text-lg pb-12 text-gray-400 max-w-3xl dark:text-slate-600 reveal reveal-left reveal-delay-2">
        {t.experienceInfo}
      </p>

      <ol className="relative border-l border-slate-700 dark:border-slate-200 ml-3">
        {t.experience.map(({ id, role, company, period, location, impact }, index) => (
          <li
            key={id}
            className={`relative pl-8 pb-10 last:pb-0 reveal reveal-left reveal-delay-${(index % 4) + 1}`}
          >
            <span
              className="absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full bg-gradient-to-tr from-violet-500 to-sky-500 ring-4 ring-slate-900 dark:ring-white"
              aria-hidden="true"
            />
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <h3 className="text-white dark:text-slate-900 font-semibold text-base">
                {role}
              </h3>
              <span className="text-violet-400 dark:text-violet-500 text-sm font-medium">
                {company}
              </span>
            </div>
            <div className="flex flex-wrap items-center gap-x-3 text-xs text-gray-500 dark:text-slate-500 mt-0.5 mb-2">
              <span>{period}</span>
              <span aria-hidden="true">•</span>
              <span>{location}</span>
            </div>
            <p className="text-sm text-gray-400 dark:text-slate-600 leading-relaxed max-w-2xl">
              {impact}
            </p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default Experience;
